import { useLang } from '../../../hooks/useLang';

export default function WarningBar() {
  const { t } = useLang();
  return (
    <div className="fixed bottom-0 left-0 right-0 z-[9998] bg-[#FF3B30] text-white text-center py-2.5 text-xs font-medium flex items-center justify-center gap-2 px-4">
      <div className="w-4 h-4 flex items-center justify-center shrink-0">
        <i className="ri-error-warning-fill text-sm"></i>
      </div>
      <span className="leading-snug">
        {t(
          '境内禁止虚拟货币交易、炒作、挖矿 \u00a0|\u00a0 境内禁止发行RWA代币、面向公众募资 \u00a0|\u00a0 RWA仅面向香港合格投资者 \u00a0|\u00a0 本站仅科普，不募资、不推介、不交易',
          'Mainland China: Virtual currency trading / speculation / mining is PROHIBITED \u00a0|\u00a0 Issuing RWA tokens or public fundraising is PROHIBITED \u00a0|\u00a0 RWA for HK Professional Investors only \u00a0|\u00a0 This site is for education only — no fundraising, no solicitation'
        )}
      </span>
    </div>
  );
}
